<input class="number-input" [ngModel]="numString" (ngModelChange)="onInputChanged($event)"
    (blur)="addTrailingZeroes($event); blur.next($event)" />